import { Transition, Dialog } from "@headlessui/react";
import { XMarkIcon, ExclamationTriangleIcon, DocumentArrowDownIcon, EnvelopeIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import { Fragment } from "react/jsx-runtime";

export default function NavigationWarningModal(props: {
  open: boolean;
  handleStayOnPage: () => void;
  handleDownloadAndNavigate: () => void;
  handleNavigateWithoutDownload: () => void;
  handleEmail: () => Promise<void>;
  isNavigationType: boolean;
}) {
  const { open, handleStayOnPage, handleDownloadAndNavigate, handleNavigateWithoutDownload, handleEmail, isNavigationType } = props;

  const [emailSubmitting, setEmailSubmitting] = useState<boolean>(false);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleStayOnPage}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    onClick={handleStayOnPage}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-orange-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationTriangleIcon className="h-6 w-6 text-orange-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                      Don't Lose Your Results!
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Your assessment results are anonymous and cannot be retrieved later. We recommend saving your results before leaving this page.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  {/* <button
                    type="button"
                    className={`${
                      emailSubmitting ? "opacity-50" : ""
                    } inline-flex items-center w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto`}
                    disabled={emailSubmitting}
                    onClick={async () => {
                      setEmailSubmitting(true);
                      await handleEmail();
                      setEmailSubmitting(false);
                    }}
                  >
                    <EnvelopeIcon className="h-4 w-4 mr-2" />
                    {!emailSubmitting ? (
                      "Email to Me"
                    ) : (
                      <svg className="h-5 w-5 animate-spin text-white ml-2" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    )}
                  </button> */}
                  <button
                    type="button"
                    className="mt-3 sm:mt-0 inline-flex items-center w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={handleDownloadAndNavigate}
                  >
                    <DocumentArrowDownIcon className="h-4 w-4 mr-2" />
                    Download{isNavigationType ? " & Continue" : ""}
                  </button>
                  {isNavigationType && (
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:ml-3"
                      onClick={handleNavigateWithoutDownload}
                    >
                      Continue Without Download
                    </button>
                  )}
                  <button
                    type="button"
                    className="mt-3 inline-flex items-center w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={handleStayOnPage}
                  >
                    Stay on Page
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
